import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${string | ':id'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:id`;

export const URL = (id: number): RouteDefinition => `${baseRoute}/${id}`;
